import {DateTime} from 'luxon';

import {reportToBugsnag} from '../../../srcCommon/services/bugsnag/bugsnag';
import {CancelToken} from '../../helpers/asyncCancelHelpers';
import {findTimeZone} from '../../helpers/dateTimeHelpers';
import {ApiApplicationAuthorizationUrl} from '../../models/api/applicationAuthorizationUrlModel';
import {ApiLegacyConference} from '../../models/api/conferenceModel';
import {IntegrationModel} from '../../models/api/integrationModel';
import {postApiAsync} from '../http/http';
import {openExternalPopupUrl} from '../popups';

export async function fetchConferenceAsync(
  integration: IntegrationModel,
  summary: string,
  startDateTime: DateTime,
  endDateTime: DateTime,
  cancelToken?: CancelToken,
) {
  const {conferenceSettings} = integration;

  if (!conferenceSettings) {
    return null;
  }

  const path = `${integration.typeUrl}${conferenceSettings.createMeetingRoute}`;
  const params = {
    summary,
    start: startDateTime.toISO(),
    end: endDateTime.toISO(),
    timezone: findTimeZone(),
  };

  try {
    const conference = await postApiAsync(ApiLegacyConference, path, params, {cancelToken});
    return conference;
  } catch (err) {
    // If we have an authentication issue, prompt the user to authenticate.
    if (err.status === 400 && err.body.status === 'invalid_credentials') {
      try {
        const authorizationUrl = await postApiAsync(
          ApiApplicationAuthorizationUrl,
          `${integration.typeUrl}${conferenceSettings.authenticateRoute}`,
          {},
        );

        const loginUrl = authorizationUrl.url;

        if (!loginUrl) {
          throw new Error('Unable to get an authorization URL.');
        }

        openExternalPopupUrl(loginUrl);
      } catch (authErr) {
        reportToBugsnag(new Error(`Failed to generate conference authorization URL: ${authErr}`), {
          metadata: {
            integration_id: integration.id,
          },
        });
      }
    } else {
      reportToBugsnag(new Error(`Failed to fetch conference: ${err}`), {
        metadata: {
          integration_id: integration.id,
        },
      });
    }

    return undefined;
  }
}
